[
  {
    "title": "Mit einem Lächeln begrüßen",
    "subtext": "Beginne das Gespräch mit einem Lächeln, das eine positive Atmosphäre schafft.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Verbreite Positivität",
    "subtext": "Positivität ist ansteckend! Teile deine positive Energie mit dem Kunden.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Zeige echte Empathie",
    "subtext": "Versetze dich in die Lage des Kunden und zeige echtes Verständnis.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Sprich selbstbewusst",
    "subtext": "Selbstbewusstes Auftreten schafft Vertrauen und Glaubwürdigkeit.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Biete personalisierte Interaktion",
    "subtext": "Verwende den Namen des Kunden, um eine personalisierte Erfahrung zu schaffen.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Freundlich begrüßen",
    "subtext": "Eine herzliche Begrüßung kann den Kunden von Anfang an das Gefühl geben, geschätzt zu werden.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Aktives Zuhören",
    "subtext": "Höre aktiv auf die Bedürfnisse und Anliegen des Kunden.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Nahtlos überleiten",
    "subtext": "Wechsle mühelos zwischen Themen für ein reibungsloses Gespräch.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Nimm stille Momente an",
    "subtext": "Habe keine Angst vor einer kurzen Stille. Gib dem Kunden Zeit zum Nachdenken.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Die Tonart des Kunden spiegeln",
    "subtext": "Spiegle das Tempo und den Ton des Kunden wider, um eine Beziehung aufzubauen.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Sei gut informiert und sachkundig",
    "subtext": "Ein gut informierter Mitarbeiter ist der beste Verbündete des Kunden.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Herausforderungen souverän meistern",
    "subtext": "Navigiere geschickt durch schwierige Situationen wie ein erfahrener Kapitän.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Ruhig und gelassen bleiben",
    "subtext": "Bleibe ruhig, auch während schwieriger Kundengespräche.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Mit einer Prise Humor",
    "subtext": "Eine Prise Humor kann jeden Anruf aufhellen.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Auf Details achten",
    "subtext": "Achte auf jedes Detail, egal wie klein es ist.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Flexibel und anpassungsfähig sein",
    "subtext": "Sei flexibel und passe deinen Ansatz bei Bedarf an.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Verbreite Positivität",
    "subtext": "Hinterlasse beim Kunden einen positiven Eindruck.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Reagiere blitzschnell",
    "subtext": "Sei auf Zack und antworte unverzüglich.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Übe dich in Geduld",
    "subtext": "Geduld zahlt sich aus und ist eine Stärke, besonders am Telefon.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Empathie schadet nie",
    "subtext": "Empathie kann Wunder in einem Gespräch bewirken.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Echtes Interesse zeigen",
    "subtext": "Zeige ehrliches Interesse an den Bedürfnissen und Wünschen des Kunden.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Kunden respektvoll behandeln",
    "subtext": "Behandle Kunden, wie du selbst behandelt werden möchtest – mit Respekt.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Erfolge feiern",
    "subtext": "Erkenne jeden kleinen Erfolg an und feiere ihn.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Kundenzufriedenheit priorisieren",
    "subtext": "Es geht nicht nur um den Verkauf, sondern um die Zufriedenheit des Kunden.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Verständnis zeigen",
    "subtext": "Zeige Verständnis mit einem einfachen \"Ich verstehe\".",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Echte Beziehung herstellen",
    "subtext": "Schaffe eine echte Verbindung, die über den Anruf hinausgeht.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Kreativität bei Lösungen einsetzen",
    "subtext": "Entfessle deine Kreativität, um Kundenherausforderungen zu lösen.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Aufrichtige Dankbarkeit ausdrücken",
    "subtext": "Bedanke dich aufrichtig dafür, dass der Kunde deinen Service gewählt hat.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Die Sprache des Kunden sprechen",
    "subtext": "Passe deine Sprache an den Stil des Kunden an.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Das Gespräch herzlich beenden",
    "subtext": "Verabschiede den Kunden herzlich.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Jeden Anruf mit vollem Einsatz angehen",
    "subtext": "Biete bei jedem Anruf hervorragenden Service.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Kunden mit einem Lächeln verabschieden",
    "subtext": "Verabschiede Kunden mit einem Lächeln.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Kundenbedürfnisse mit Emotionen verbinden",
    "subtext": "Nutze Emotionen, um dich mit Kunden zu verbinden.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Mit einem Lächeln grüßen",
    "subtext": "Starte das Gespräch mit einem strahlenden Lächeln!",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Empathisch sein",
    "subtext": "Fühl' dich in den Kunden hinein und zeige echtes Verständnis.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Selbstbewusst sprechen",
    "subtext": "Deine Stimme ist stark – sprich mit Selbstbewusstsein!",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Kunden mit Namen ansprechen",
    "subtext": "Ein persönliche Ansprache mit dem Namen des Kunden wirkt Wunder.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Herzlich grüßen",
    "subtext": "Eine freundliche Begrüßung zaubert ein Lächeln aufs Gesicht.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Aufmerksam zuhören",
    "subtext": "Höre aufmerksam zu und verstehe die Bedürfnisse des Kunden.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Gesprächsthemen geschmeidig wechseln",
    "subtext": "Wechsle geschickt zwischen Themen, um das Gespräch flüssig zu halten.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Lösungen mit einem Lächeln anbieten",
    "subtext": "Probleme lösen mit einem Lächeln – das ist der Weg!",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Sorgfältig agieren",
    "subtext": "Behandle jeden Anruf mit Sorgfalt, als wäre es eine zarte Blume.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Produktwissen zeigen",
    "subtext": "Ein Profi weiß Bescheid – teile dein Wissen mit dem Kunden.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Ruhe bewahren",
    "subtext": "Gelassenheit bewahren, auch wenn's stürmisch wird.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Eine Prise Humor hinzufügen",
    "subtext": "Ein Lächeln ist der beste Eisbrecher – füge eine Prise Humor hinzu!",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Kundenideen aufgreifen und erweitern",
    "subtext": "Kundenideen sind Schätze – erweitere sie mit deinem Fachwissen.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Auf Details achten",
    "subtext": "Achte auf jedes Detail – es kann den Unterschied machen.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Flexibel sein",
    "subtext": "Flexibilität ist der Schlüssel – passe dich dem Kunden an.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Positiven Eindruck hinterlassen",
    "subtext": "Jeder Anruf hinterlässt Spuren – sorge für einen positiven Eindruck.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Schnell reagieren",
    "subtext": "Schnell und präzise antworten – Kunden schätzen das.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Verantwortung übernehmen",
    "subtext": "Übernehme die Verantwortung für den Anruf – du hast das Zepter!",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Emotionale Intelligenz zeigen",
    "subtext": "Fühle mit dem Kunden mit – Emotionen sind der Schlüssel.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Positive Energie ausstrahlen",
    "subtext": "Verbreite Positivität wie ein Sonnenstrahl – der Kunde wird es spüren.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Kundenbeziehungen aufbauen",
    "subtext": "Schaffe eine Brücke zwischen Kundenbedürfnissen und Lösungen.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Echtes Interesse zeigen",
    "subtext": "Zeige echtes Interesse am Kunden – das schafft Vertrauen.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Kunden respektvoll behandeln",
    "subtext": "Behandle Kunden, wie du selbst behandelt werden möchtest – mit Respekt.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Kundenzufriedenheit priorisieren",
    "subtext": "Denk an die Kundenzufriedenheit, nicht nur an den Verkauf.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Verständnis zeigen",
    "subtext": "Mit \"Ich verstehe\" zeigst du Verständnis – ein kleiner Schritt für dich, ein großer für den Kunden.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Mit Einfühlungsvermögen punkten",
    "subtext": "Punkte mit Einfühlungsvermögen – der Kunde wird es schätzen.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Mit Begeisterung Lösungen präsentieren",
    "subtext": "Präsentiere Lösungen mit Leidenschaft und Begeisterung.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Die Kunst des Umgangs mit Beschwerden meistern",
    "subtext": "Verwandele Beschwerden in Lösungen.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Auf Fünf-Sterne-Service hinarbeiten",
    "subtext": "Strebe nach Service, der fünf Sterne verdient – jeder Anruf zählt.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Erfolgsgeschichten von Kunden teilen",
    "subtext": "Teile inspirierende Erfolgsgeschichten von anderen Kunden.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Jeden Anruf mit vollem Einsatz angehen",
    "subtext": "Gib in jedem Anruf vollen Einsatz – du bist ein Profi!",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Kunden mit einem Lächeln verabschieden",
    "subtext": "Verabschiede Kunden mit einem herzlichen Lächeln.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Die Kraft der Worte nutzen",
    "subtext": "Nutze deine Worte, um Kunden zu begeistern und zu überzeugen.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Den Funken der Neugier entzünden",
    "subtext": "Entzünde den Funken der Neugier beim Kunden – erkunde Bedürfnisse.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Den Kunden in den Mittelpunkt stellen",
    "subtext": "Setze den Kunden ins Zentrum deines Handelns – er ist der Star!",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Mit Wissen glänzen",
    "subtext": "Teile dein Wissen – der Kunde wird davon profitieren",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Einfachheit und Klarheit anbieten",
    "subtext": "Biete Einfachheit und Klarheit – der Kunde wird es zu schätzen wissen.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Ein Ass im Ärmel haben",
    "subtext": "Hab immer ein Ass im Ärmel – sei vorbereitet auf alles.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Kunden wie Könige behandeln",
    "subtext": "Behandle Kunden wie Könige – sie verdienen königlichen Service.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Kundenwünsche zuhören und erfüllen",
    "subtext": "Höre auf Kundenwünsche und erfülle sie – das ist der Weg zum Erfolg.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Kundenbedürfnisse wie ein Profi analysieren",
    "subtext": "Analysiere Kundenbedürfnisse wie ein Profi – finde den Schlüssel.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Mit Persönlichkeit und Kreativität glänzen",
    "subtext": "Glänze mit Persönlichkeit und Kreativität – sei ein Star im Gespräch.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Mit einem Lächeln in den Anruf starten",
    "subtext": "Starte mit einem Lächeln – das überträgt sich auf den Kunden.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Mit Energie und Leidenschaft begeistern",
    "subtext": "Begeistere mit Energie und Leidenschaft – das überträgt sich auf den Kunden.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Den Kunden wie einen Partner behandeln",
    "subtext": "Behandle den Kunden wie einen Partner – ihr seid ein Team.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Mit Freude und Engagement überzeugen",
    "subtext": "Überzeuge mit Freude und Engagement – der Kunde wird dir folgen.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Mit Fachwissen und Begeisterung glänzen",
    "subtext": "Glänze mit Fachwissen und Begeisterung – du bist der Experte.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Den Kunden mit einem Lächeln verzaubern",
    "subtext": "Verzaubere den Kunden mit einem strahlenden Lächeln.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Die Kunst der Kundenbindung meistern",
    "subtext": "Meistere die Kunst der Kundenbindung – schaffe langanhaltende Beziehungen.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Den Kunden mit Leichtigkeit überzeugen",
    "subtext": "Überzeuge den Kunden mit Leichtigkeit – du bist ein Profi.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Mit Professionalität und Respekt glänzen",
    "subtext": "Glänze mit Professionalität und Respekt – der Kunde wird es schätzen.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Kundenbeziehungen aufbauen",
    "subtext": "Überwinde die Lücke zwischen Lösungen und den Bedürfnissen des Kunden.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Dankbarkeit zeigen",
    "subtext": "Zeige Dankbarkeit für die Zeit und den Anruf des Kunden.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Kundenideen aufgreifen und erweitern",
    "subtext": "Nimm Kundenideen auf und erweitere sie auf positive Weise.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Verantwortung für den Anruf übernehmen",
    "subtext": "Übernimm Verantwortung für den Anruf und die Anliegen des Kunden.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Etwas bewirken",
    "subtext": "Passe deinen Ansatz individuell an, um wirklich etwas zu bewirken.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Gefühle und Anliegen anerkennen",
    "subtext": "Erkenne die Gefühle und Erfahrungen des Kunden an.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Mit einem Lächeln beraten",
    "subtext": "Beraten Sie den Kunden mit einem freundlichen Lächeln.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Offene Fragen stellen",
    "subtext": "Stelle offene Fragen, um eine tiefere Konversation anzuregen.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Erfolgsgeschichten von Kunden teilen",
    "subtext": "Inspirieren Sie mit Erfolgsgeschichten von Kunden.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Kunden zum Erfolg führen",
    "subtext": "Kunden auf den Weg zum Erfolg führen.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Lösungen in den Mittelpunkt stellen",
    "subtext": "Hebe Lösungen hervor und stelle sie ins Rampenlicht.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Lösungsvielfalt nutzen",
    "subtext": "Überrasche Kunden mit kreativen Lösungen.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "In Kundenbeziehungen investieren",
    "subtext": "Kundebeziehungen sind wertvolle Investitionen",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Sorgfältig behandeln",
    "subtext": "Behandeln Sie jeden Anruf mit Sorgfalt und Aufmerksamkeit.",
    "logic": "before-the-call",
    "topic": "generic-phrases",
    "category": "generic"
  },
  {
    "title": "Der Morgen ruft!",
    "category": "morning",
    "iconName": "Morning",
    "subtext": "Lass uns die Welt mit Freundlichkeit und Lächeln erfüllen.",
    "logic": "before-the-call",
    "topic": "greeting-based-on-time-of-the-day"
  },
  {
    "title": "Ein neuer Tag beginnt!",
    "category": "morning",
    "iconName": "Morning",
    "subtext": "Morgenstund hat Gold im Mund, mach was draus!",
    "logic": "before-the-call",
    "topic": "greeting-based-on-time-of-the-day"
  },
  {
    "title": "Guten Start in den Tag!",
    "category": "morning",
    "iconName": "Morning",
    "subtext": "Der frühe Vogel fängt den Wurm, auf einen erfolgreichen Tag!",
    "logic": "before-the-call",
    "topic": "greeting-based-on-time-of-the-day"
  },
  {
    "title": "Hallihallo, Welt!",
    "category": "morning",
    "iconName": "Morning",
    "subtext": "Der Morgen macht den Tag!",
    "logic": "before-the-call",
    "topic": "greeting-based-on-time-of-the-day"
  },
  {
    "title": "Einen zauberhaften Tag!",
    "category": "morning",
    "iconName": "Morning",
    "subtext": "Lass die guten Vibes fließen!",
    "logic": "before-the-call",
    "topic": "greeting-based-on-time-of-the-day"
  },
  {
    "title": "Einen wunderschönen Morgen!",
    "category": "morning",
    "iconName": "Morning",
    "subtext": "Beginne den Tag mit guter Stimmung!",
    "logic": "before-the-call",
    "topic": "greeting-based-on-time-of-the-day"
  },
  {
    "title": "Guten Morgen, Sonnenschein!",
    "category": "morning",
    "iconName": "Morning",
    "subtext": "Wir senden dir gute Vibes für einen fantastischen Morgen!",
    "logic": "before-the-call",
    "topic": "greeting-based-on-time-of-the-day"
  },
  {
    "title": "Starte deinen Tag mit einem Lächeln!",
    "category": "morning",
    "iconName": "Morning",
    "subtext": "Glaube an dich selbst und an alles, was du erreichen kannst!",
    "logic": "before-the-call",
    "topic": "greeting-based-on-time-of-the-day"
  },
  {
    "title": "Hallo, neuer Tag!",
    "category": "morning",
    "iconName": "Morning",
    "subtext": "Ein frischer Start in den Tag, ein neuer Anfang. Mach was draus!",
    "logic": "before-the-call",
    "topic": "greeting-based-on-time-of-the-day"
  },
  {
    "title": "Der Morgen ruft!",
    "category": "morning",
    "iconName": "Morning",
    "subtext": "Der frühe Vogel fängt den Wurm, auf einen erfolgreichen Tag!",
    "logic": "before-the-call",
    "topic": "greeting-based-on-time-of-the-day"
  },
  {
    "title": "Ein neuer Tag beginnt!",
    "category": "morning",
    "iconName": "Morning",
    "subtext": "Lass uns die Welt mit Freundlichkeit und Lächeln erfüllen.",
    "logic": "before-the-call",
    "topic": "greeting-based-on-time-of-the-day"
  },
  {
    "title": "Guten Start in den Tag!",
    "category": "morning",
    "iconName": "Morning",
    "subtext": "Morgenstund hat Gold im Mund, mach was draus!",
    "logic": "before-the-call",
    "topic": "greeting-based-on-time-of-the-day"
  },
  {
    "title": "Einen zauberhaften Tag!",
    "category": "morning",
    "iconName": "Morning",
    "subtext": "Der Morgen macht den Tag!",
    "logic": "before-the-call",
    "topic": "greeting-based-on-time-of-the-day"
  },
  {
    "title": "Willkommen zu einem neuen Tag!",
    "category": "morning",
    "iconName": "Morning",
    "subtext": "Wir wünschen dir einen Tag voller Freude und Produktivität!",
    "logic": "before-the-call",
    "topic": "greeting-based-on-time-of-the-day"
  },
  {
    "title": "Guten Tag!",
    "category": "afternoon",
    "iconName": "Afternoon",
    "subtext": "Zieh's weiter durch! Denk dran: Jeder kleine Schritt zählt, um deine Ziele zu erreichen!",
    "logic": "before-the-call",
    "topic": "greeting-based-on-time-of-the-day"
  },
  {
    "title": "Einen angenehmen Tag!",
    "category": "afternoon",
    "iconName": "Afternoon",
    "subtext": "Du machst einen tollen Job! Bleib konzentriert und behalt das Ziel im Auge!",
    "logic": "before-the-call",
    "topic": "greeting-based-on-time-of-the-day"
  },
  {
    "title": "Hallo, jetzt beginnt der Nachmittag!",
    "category": "afternoon",
    "iconName": "Afternoon",
    "subtext": "Nimm dir einen Moment, um zu reflektieren, wie weit du heute gekommen bist.",
    "logic": "before-the-call",
    "topic": "greeting-based-on-time-of-the-day"
  },
  {
    "title": "Wir wünschen dir einen schönen Tag!",
    "category": "afternoon",
    "iconName": "Afternoon",
    "subtext": "Nimm dir ein paar Minuten, um in Ruhe nachzudenken.",
    "logic": "before-the-call",
    "topic": "greeting-based-on-time-of-the-day"
  },
  {
    "title": "Einen wunderschönen Tag!",
    "category": "afternoon",
    "iconName": "Afternoon",
    "subtext": "Jeder kleine Schritt bringt dich deinem Ziel näher.",
    "logic": "before-the-call",
    "topic": "greeting-based-on-time-of-the-day"
  },
  {
    "title": "Mittagszeit!",
    "category": "afternoon",
    "iconName": "Afternoon",
    "subtext": "Du hast es drauf, jetzt nicht langsamer werden!",
    "logic": "before-the-call",
    "topic": "greeting-based-on-time-of-the-day"
  },
  {
    "title": "So weit, so gut?",
    "category": "afternoon",
    "iconName": "Afternoon",
    "subtext": "Kleine Erinnerung: Bleibe auf Kurs und mach weiter so!",
    "logic": "before-the-call",
    "topic": "greeting-based-on-time-of-the-day"
  },
  {
    "title": "Hallihallo, Welt!",
    "category": "afternoon",
    "iconName": "Afternoon",
    "subtext": "Lass die guten Vibes fließen!",
    "logic": "before-the-call",
    "topic": "greeting-based-on-time-of-the-day"
  },
  {
    "title": "Glückwunsch zum #numberOfCalls#. Anruf!",
    "subtext": "Mach weiter so und behalte dein Ziel im Auge.",
    "logic": "after-the-call",
    "topic": "call-related-call-count",
    "category": "after-the-x-call",
    "iconName": "TenthCall",
    "group": 1
  },
  {
    "title": "Gut gemacht, dein #numberOfCalls#. Anruf!",
    "subtext": "Weiter so mit Blick aufs Ziel!",
    "logic": "after-the-call",
    "topic": "call-related-call-count",
    "category": "after-the-x-call",
    "iconName": "TenthCall",
    "group": 1
  },
  {
    "title": "Bravo zum #numberOfCalls#. Anruf!",
    "subtext": "Bleibe auf Kurs und behalte dein Ziel im Auge.",
    "logic": "after-the-call",
    "topic": "call-related-call-count",
    "category": "after-the-x-call",
    "iconName": "TenthCall",
    "group": 1
  },
  {
    "title": "High Five zu deinem #numberOfCalls#. Anruf!",
    "subtext": "Bleibe am Ball und verliere das Endziel nicht aus den Augen.",
    "logic": "after-the-call",
    "topic": "call-related-call-count",
    "category": "after-the-x-call",
    "iconName": "TenthCall",
    "group": 1
  },
  {
    "title": "Glückwunsch zu deinem #numberOfCalls#. Anruf!",
    "subtext": "Bleibe dabei, um das Ziel zu erreichen.",
    "logic": "after-the-call",
    "topic": "call-related-call-count",
    "category": "after-the-x-call",
    "iconName": "TenthCall",
    "group": 1
  },
  {
    "title": "Hurra!",
    "subtext": "Bleibe beharrlich und behalte das Ergebnis im Auge.",
    "logic": "after-the-call",
    "topic": "call-related-call-count",
    "category": "after-the-x-call",
    "iconName": "TenthCall",
    "group": 1
  },
  {
    "title": "Großartige Leistung beim #numberOfCalls#. Anruf!",
    "subtext": "Den Blick vorwärts und die Aufmerksamkeit aufs Ziel richten.",
    "logic": "after-the-call",
    "topic": "call-related-call-count",
    "category": "after-the-x-call",
    "iconName": "TenthCall",
    "group": 1
  },
  {
    "title": "Daumen hoch zu deinem #numberOfCalls#. Anruf!",
    "subtext": "Zeit, zum nächsten Anruf zu gehen.",
    "logic": "after-the-call",
    "topic": "call-related-call-count",
    "category": "after-the-x-call",
    "iconName": "TenthCall",
    "group": 1
  },
  {
    "title": "Applaus zu deinem #numberOfCalls#. Anruf!",
    "subtext": "Lass uns mit dem nächsten Anruf weitermachen.",
    "logic": "after-the-call",
    "topic": "call-related-call-count",
    "category": "after-the-x-call",
    "iconName": "TenthCall",
    "group": 1
  },
  {
    "title": "Den #numberOfCalls#. Anruf gut erledigt!",
    "subtext": "Zeit, zum nächsten Anruf überzugehen.",
    "logic": "after-the-call",
    "topic": "call-related-call-count",
    "category": "after-the-x-call",
    "iconName": "TenthCall",
    "group": 1
  },
  {
    "title": "Wow, was für ein Tag!",
    "subtext": "Du hast heute schon #ordinal# #calls# gemeistert!",
    "logic": "after-the-call",
    "topic": "call-related-call-count",
    "category": "after-the-x-call",
    "iconName": "TenthCall",
    "group": 2
  },
  {
    "title": "Wirklich beeindruckend!",
    "subtext": "Auch deinen #numberOfCalls#. Anruf hast du erfolgreich hinter dich gebracht!",
    "logic": "after-the-call",
    "topic": "call-related-call-count",
    "category": "after-the-x-call",
    "iconName": "TenthCall",
    "group": 2
  },
  {
    "title": "#ordinal# #calls# geschafft bis jetzt!",
    "subtext": "Wie viele #calls# wirst du heute schaffen?",
    "logic": "after-the-call",
    "topic": "call-related-call-count",
    "category": "after-the-x-call",
    "iconName": "TenthCall",
    "group": 2
  },
  {
    "title": "Unglaublich und phänomenal!",
    "subtext": "Du hattest schon #ordinal# #calls# heute. Weiter geht's!",
    "logic": "after-the-call",
    "topic": "call-related-call-count",
    "category": "after-the-x-call",
    "iconName": "TenthCall",
    "group": 2
  },
  {
    "title": "Fantastische Arbeit!",
    "subtext": "Du hast heute erfolgreich #ordinal# #calls# abgeschlossen.",
    "logic": "after-the-call",
    "topic": "call-related-call-count",
    "category": "after-the-x-call",
    "iconName": "TenthCall",
    "group": 2
  },
  {
    "title": "Du bist der Hammer!",
    "subtext": "Du hast heute #ordinal# #calls# erledigt.",
    "logic": "after-the-call",
    "topic": "call-related-call-count",
    "category": "after-the-x-call",
    "iconName": "TenthCall",
    "group": 2
  },
  {
    "title": "Du bist mit Begeisterung dabei!",
    "subtext": "Ausgezeichnete Arbeit, du hast heute #ordinal# #calls# abgeschlossen.",
    "logic": "after-the-call",
    "topic": "call-related-call-count",
    "category": "after-the-x-call",
    "iconName": "TenthCall",
    "group": 2
  },
  {
    "title": "Du machst unglaubliche Fortschritte!",
    "subtext": "Mit dem #numberOfCalls#. Anruf hast du einen Meilenstein erreicht, mach weiter so!",
    "logic": "after-the-call",
    "topic": "call-related-call-count",
    "category": "after-the-x-call",
    "iconName": "TenthCall",
    "group": 2
  },
  {
    "title": "Weiter so!",
    "subtext": "Schon #ordinal# #calls# erledigt für heute.",
    "logic": "after-the-call",
    "topic": "call-related-call-count",
    "category": "after-the-x-call",
    "iconName": "TenthCall",
    "group": 2
  },
  {
    "title": "Unaufhaltsam!",
    "subtext": "Du hast heute schon #ordinal# #calls# geschafft!",
    "logic": "after-the-call",
    "topic": "call-related-call-count",
    "category": "after-the-x-call",
    "iconName": "TenthCall",
    "group": 2
  }
]
